import { useState } from 'react';
const DEFAULT_GRANT_DATA_TYPE = 'username';

const useCustomHook = () => {
  const [activeTab, setActiveTab] = useState(1);
  const [panelClientId, setPanelClientId] = useState(null);
  const [isNewPermissionOpen, setIsNewPermissionOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [grantUserDataType, setGrantUserDataType] = useState(DEFAULT_GRANT_DATA_TYPE);
  const [, setGrantUserData] = useState('');
  const [resfreshList, setRefreshList] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotoalCount] = useState(0);
  const [removing, setRemoving] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);

  const [list, setList] = useState([]);
  const [hasError, setHasError] = useState(false);
  const [currentDevice, setCurrentDevice] = useState(null);

  const [loading, setLoading] = useState(false);
  return {
    currentPage, setCurrentPage,
    totalCount, setTotoalCount,
    loading,
    setLoading,
    removing,
    setRemoving,
    openDialog,
    setOpenDialog,
    list,
    setList,
    hasError,
    setHasError,
    currentDevice,
    setCurrentDevice,

    panelClientId,
    setPanelClientId,
    isNewPermissionOpen,
    setIsNewPermissionOpen,
    grantUserDataType,
    setGrantUserDataType,
    resfreshList,
    setRefreshList,
    setGrantUserData,
    isLoading,
    setIsLoading,

    activeTab,
    setActiveTab,
  };
};

export default useCustomHook;
